"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFlexDirection = exports.setJustifyContent = exports.setAlignItems = exports.setWrap = exports.setFill = exports.setDisplay = void 0;
var styled_components_1 = require("styled-components");
var escapeCss_1 = __importDefault(require("../../helperFunctions/escapeCss"));
var media_1 = __importDefault(require("../media"));
var setDisplay = function (type, size) {
    if (size === void 0) { size = "xs"; }
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
        ";\n"])), media_1.default.min[size](templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: -ms- ", "box !important;\n    display: ", " !important;\n  "], ["\n    display: -ms- ", "box !important;\n    display: ", " !important;\n  "])), escapeCss_1.default(type), escapeCss_1.default(type)));
};
exports.setDisplay = setDisplay;
var setFill = function (size) {
    if (size === void 0) { size = "xs"; }
    return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
        ";\n"])), media_1.default.min[size](templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  "], ["\n    -ms-flex: 1 1 auto !important;\n    flex: 1 1 auto !important;\n  "]))));
};
exports.setFill = setFill;
var setWrap = function (type, size) {
    if (type === void 0) { type = "wrap"; }
    if (size === void 0) { size = "xs"; }
    return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
        ";\n"])), media_1.default.min[size](templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    -ms-flex-wrap: ", ";\n    flex-wrap: ", ";\n  "], ["\n    -ms-flex-wrap: ", ";\n    flex-wrap: ", ";\n  "])), escapeCss_1.default(type), escapeCss_1.default(type)));
};
exports.setWrap = setWrap;
var alignItemsCssHelper = function (oldProp, newProp) { return styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  -webkit-box-align: ", " !important;\n  -ms-flex-align: ", " !important;\n  align-items: ", " !important;\n"], ["\n  -webkit-box-align: ", " !important;\n  -ms-flex-align: ", " !important;\n  align-items: ", " !important;\n"])), escapeCss_1.default(oldProp), escapeCss_1.default(oldProp), escapeCss_1.default(newProp)); };
var setAlignItems = function (side) {
    switch (side) {
        case "start":
            return alignItemsCssHelper(side, "flex-" + side);
        case "end":
            return alignItemsCssHelper(side, "flex-" + side);
        default:
            return alignItemsCssHelper(side, side);
    }
};
exports.setAlignItems = setAlignItems;
var justifyContentCssHelper = function (oldProp, newProp) { return styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  -webkit-box-pack: ", " !important;\n  -ms-flex-pack: ", " !important;\n  justify-content: ", " !important;\n"], ["\n  -webkit-box-pack: ", " !important;\n  -ms-flex-pack: ", " !important;\n  justify-content: ", " !important;\n"])), escapeCss_1.default(oldProp), escapeCss_1.default(oldProp), escapeCss_1.default(newProp)); };
var setJustifyContent = function (side) {
    switch (side) {
        case "start":
        case "end":
            return justifyContentCssHelper(side, "flex-" + side);
        case "between":
            return justifyContentCssHelper("justify", "space-between");
        case "around":
            return justifyContentCssHelper("distribute", "space-around");
        default:
            return justifyContentCssHelper(side, side);
    }
};
exports.setJustifyContent = setJustifyContent;
var directionCssHelper = function (oldPropOrient, oldPropDirection, newProp) {
    return styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    -webkit-box-orient: ", ";\n    -webkit-box-direction: ", ";\n    -ms-flex-direction: ", ";\n    flex-direction: ", ";\n  "], ["\n    -webkit-box-orient: ", ";\n    -webkit-box-direction: ", ";\n    -ms-flex-direction: ", ";\n    flex-direction: ", ";\n  "])), escapeCss_1.default(oldPropOrient), escapeCss_1.default(oldPropDirection), escapeCss_1.default(newProp), escapeCss_1.default(newProp));
};
var setFlexDirection = function (dir) {
    switch (dir) {
        case "row":
            return directionCssHelper("horizontal", "normal", dir);
        case "row-reverse":
            return directionCssHelper("horizontal", "reverse", dir);
        case "column":
            return directionCssHelper("vertical", "normal", dir);
        case "column-reverse":
            return directionCssHelper("vertical", "reverse", dir);
        default:
            return null;
    }
};
exports.setFlexDirection = setFlexDirection;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=flex.js.map